import React, { useEffect, useState } from 'react'
import { Button, Header } from '../../components'
import { Bs7Circle, BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import Loading from '../../components/Loading';
import { useStateContext } from '../../contexts/ContextProvider';
import { AiTwotoneEdit } from 'react-icons/ai';
import ActionButton from '../../components/ActionButton';

import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import TabHead from '../../components/TabHead';
import MySelect from '../../components/MySelect';
import { IoIosSearch } from 'react-icons/io';
import Alert from '../../components/Alert';
import HourLoading from '../../components/HourLoading';
import { GrWorkshop } from 'react-icons/gr';
import { MdAccountBalanceWallet } from 'react-icons/md';
import EditEnseignant from './EditEnseignant';
import AddEnseignant from './AddEnseignant';
import CompteEnseignant from './CompteEnseignant';


const Enseignants = () => {
    const navigate = useNavigate();
    const [enseignants, setEnseignants] = useState(null);
    const [loading, setLoading] = useState(false);
    const { token, setToken, user } = useStateContext();
    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showCompte, setShowCompte] = useState(false);
    const [selectedEnseignant, setSelectedEnseignant] = useState(null);
    const [etat, setEtat] = useState([
        {
            id: 1,
            libelle: 'Actif',
        },
        {
            id: 0,
            libelle: 'Inactif',
        }
    ]);
    const [selectedEtat, setSelectedEtat] = useState(null);
    const [inputValueEtat, setValueEtat] = useState('');
    const [errors, setErrors] = useState([]);
    const handleInputChangeEtat = value => {
        setValueEtat(value);
    };



    // handle selection


    // handle selection
    const handleChangeEtat = value => {
        setSelectedEtat(value);


    }
    const getEnseignants = () => {
        if (selectedEtat != null) {
            setLoading(true);
            axiosClient.get('/enseignants?etat=' + selectedEtat.id)
                .then((data) => {
                    setEnseignants(data.data.enseignants);
                    setLoading(false);

                }).catch(err => {
                    const response = err.response;
                    if (response.status === 401) {
                        setToken(null);
                    }
                    else {
                        if (response.status === 422) {
                            setErrors(response.data.errors);
                            setLoading(false);
                            toast.error('Une erreur est survenue!', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        } else {
                            if (response.status === 403) {
                                navigate('/403');
                            } else {
                                if (response.status === 404) {
                                    navigate('/404');
                                }
                                else {
                                    navigate('/500');
                                }
                            }
                        }

                    }
                })
        } else {
            toast.error('Selectionez un Etat!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }




    const supprimer = (enseignant) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/enseignant/' + enseignant.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getEnseignants();
                    }).catch(err => {
                        const response = err.response;
                        if (err.response.status === 401) {
                            setToken(null);
                        } else {
                            if (response.status === 401) {
                                setToken(null);
                            }
                            else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
                        }

                    })
            }
        });
    }

    const closeShowAdd = () => {
        setShowAdd(false);
        setSelectedEnseignant(null);
        //getEnseignants();
    }
    const closeShowEdit = () => {
        setShowEdit(false);
        setSelectedEnseignant(null);
        getEnseignants();
    }

    const closeShowCompte = () => {
        setShowCompte(false);
        setSelectedEnseignant(null);
        //getEnseignants();
    }

    useEffect(() => {

    }, []);

    return (
        <>
            <Header icon={<GrWorkshop />} category='Page' title='Enseignants' titleAr="المدرسون و الأساتذة" />
            <div className='flex-col '>
                <div className='flex w-full flex-wrap md:flex-nowrap justify-between lg:flex-nowrap xl:flex-nowrap items-center gap-2'>
                    {
                        user.role && user.role.name === 'admin' ? <Button onClick={() => setShowAdd(true)} color="bg-blue-500" icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
                            : <></>
                    }
                    <div className="flex gap-2">
                        <MySelect label="Etat" labelAr="الوضعية" placeholder="Etat" cacheOptions defaultOptions value={selectedEtat} getOptionLabel={e => e.libelle} getOptionValue={e => e.id} options={etat} onInputChange={handleInputChangeEtat} onChange={handleChangeEtat} />
                        <div className="mt-8">
                            <Button onClick={() => getEnseignants()} color="bg-yellow-500" icon={<IoIosSearch />} size="20" text="Chercher" textColor="text-white" />
                        </div>
                    </div>
                </div>
                {errors &&
                    Object.keys(errors).map(key => (
                        <Alert key={key} message={errors[key][0]} />
                    ))
                }
                <div className='mt-3 w-full overflow-x-auto'>
                    {loading ? <HourLoading /> :
                        (
                            <table className='table-auto'>
                                <thead>
                                    <tr>
                                        <th><TabHead left="Matricule" right="المعرف" />  </th>
                                        <th><TabHead left="Nom" right="الإسم" />  </th>
                                        <th><TabHead left="Tel" right="الهاتف" /> </th>
                                        <th><TabHead left="Etat" right="الوضعية" /> </th>
                                        <th><TabHead left="Actions" right={"إجراء"} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {enseignants && enseignants.map(o => (
                                        <tr key={o.id}>
                                            <td>{o.matricule}</td>
                                            <td>{o.nom}</td>
                                            <td>{o.tel}</td>
                                            <th>{o.etatName}</th>
                                            <td>
                                                <div className="flex justify-evenly">
                                                    {
                                                        user.role && user.role.name === 'caissier' ? <></>
                                                            : <ActionButton onClick={() => {
                                                                setSelectedEnseignant(o);
                                                                setShowEdit(true);
                                                            }} color="bg-green-500" icon={<AiTwotoneEdit />} textColor="text-white" title="Modifier" />
                                                    }
                                                    <ActionButton onClick={() => {
                                                        setSelectedEnseignant(o);
                                                        setShowCompte(true);
                                                    }} color="bg-blue-500" icon={<MdAccountBalanceWallet />} textColor="text-white" title="Compte" />
                                                </div>
                                            </td>
                                        </tr>
                                    ))

                                    }
                                </tbody>
                            </table>
                        )

                    }
                    {showEdit ? <EditEnseignant updatedEnseignant={selectedEnseignant} onClose={closeShowEdit} /> : <></>}
                    {showAdd ? <AddEnseignant onClose={closeShowAdd} /> : <></>}
                    {showCompte ? <CompteEnseignant selectedEnseignant={selectedEnseignant} onClose={closeShowCompte} /> : <></>}
                </div>

            </div>
        </>
    )
}

export default Enseignants